export default "__VITE_ASSET__MJqjIXDF__"